import { request } from "services/api/util";

class SampleProductService {
  async getListSamplePickupCounter(params) {
    const config = {
      method: "get",
      url: `admin/samplePickupCounters`,
      params: params,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async getDeliveryLabels(params) {
    const config = {
      method: "get",
      url: `admin/sampleProductVouchers/deliveryLabels`,
      params: params,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }
}

export default new SampleProductService();
